import { FadeIn } from 'react-native-reanimated';

export const FADE_IN_DURATION = 500;

export const fadeIn = FadeIn.duration(FADE_IN_DURATION);
